// extracted by mini-css-extract-plugin
export default {"root":"AnswerEditor_root__KboJL","title":"AnswerEditor_title__QeiHs","footer":"AnswerEditor_footer__EH-H9"};